var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.462,
    viewBox: "0 0 46 44.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_illustration",
    d: "M12.192,50.486a12.448,12.448,0,0,1-4.123-.708A9.011,9.011,0,0,1,4.5,47.47a5.718,5.718,0,0,0,3.077-2.154A6.909,6.909,0,0,0,8.5,41.5a6.409,6.409,0,0,1,6.461-6.461A6.409,6.409,0,0,1,21.423,41.5a8.486,8.486,0,0,1-2.677,6.461A9.2,9.2,0,0,1,12.192,50.486ZM26.346,35.9l-5.538-5.846L43.945,6.917a2.769,2.769,0,0,1,1.908-.892,2.646,2.646,0,0,1,1.969.892L49.607,8.7a2.677,2.677,0,0,1,.892,2,2.8,2.8,0,0,1-.892,1.938Z",
    transform: "translate(-4.5 -6.024)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIllustration);
export default __webpack_public_path__ + "static/media/skills_illustration.be942309cf0e7c2ac49bc8617494d7c6.svg";
export { ForwardRef as ReactComponent };